import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { districts, productOptions } from "../Options";
import Sidebar from "../Sidebar";
// import env from "react-dotenv";

export default function EditIntention() {
  const [form, setForm] = useState({
    district: "",
    district_id: "",
    owner: "",
    leaser: "",
    year: "",
  });

  //loosing
  const [loosing, setLoosing] = useState([
    {
      crop: "",
      amount: "",
    },
  ]);

  //gaining
  const [gaining, setGaining] = useState([
    {
      crop: "",
      amount: "",
    },
  ]);

  //handle click
  const handleClick = () => {
    setLoosing([...loosing, { crop: "", amount: "" }]);
  };

  const handleClick1 = () => {
    setGaining([...gaining, { crop: "", amount: "" }]);
  };

  //handle change
  const handleChange = (e, i) => {
    const { name, value } = e.target;
    const onChangeVal = [...loosing];
    onChangeVal[i][name] = value;
    setLoosing(onChangeVal);
  };

  const handleChange1 = (e, i) => {
    const { name, value } = e.target;
    const onChangeVal = [...gaining];
    onChangeVal[i][name] = value;
    setGaining(onChangeVal);
  };

  useEffect(() => {
   // console.log(loosing);
  }, [loosing]);

  //handle delete
  const handleDelete = (i) => {
    const deleteVal = [...loosing];
    deleteVal.splice(i, 1);
    setLoosing(deleteVal);
  };

  const handleDelete1 = (i) => {
    const deleteVal = [...gaining];
    deleteVal.splice(i, 1);
    setGaining(deleteVal);
  };
  //reference
  const dRef = useRef();
  const oRef = useRef();
  const leRef = useRef();
  const yRef = useRef();

  //year handler
  const yearHandler = (e) => {
    const x = e.target.value;
    setForm({ ...form, year: x });
  };

  //district handler
  const districtHandler = (e) => {
    const selectedName = e.target.value;
    const selectedOption = districts.find(
      (district) => district.district === selectedName
    );
   // console.log(selectedOption);
    setForm({
      ...form,
      district: selectedOption.district,
      district_id: selectedOption.district_id,
    });
  };

  useEffect(() => {
   // console.log(form.district);
  }, [form]);

  //owner handler
  const ownerHandler = (e) => {
    setForm({ ...form, owner: e.target.value, leaser: 100 - e.target.value });
  };

  useEffect(() => {
   // console.log(form.owner);
  }, [form]);

  //leaser handler
  const leaserHandler = (e) => {
    setForm({ ...form, leaser: e.target.value });
  };

  useEffect(() => {
   // console.log(form.leaser);
  }, [form]);

  //loosing handler
  const loosingHandler = (e) => {
    setForm({ ...form, loosing: e.target.value });
  };

  useEffect(() => {
   // console.log(form.loosing);
  }, [form]);

  //gaining handler
  const gainingHandler = (e) => {
    setForm({ ...form, gaining: e.target.value });
  };

  useEffect(() => {
   // console.log(form.gaining);
  }, [form]);

  //gaining handler
  const cropHandler = (e) => {
    setForm({ ...form, crop: e.target.value });
  };

  useEffect(() => {
   // console.log(form.crop);
  }, [form]);

  useEffect(() => {
   // console.log(form);
  }, [form]);

  const { _id } = useParams();
  //get the items
  const gerrit = async () => {
    const token = sessionStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/getIntentions/${_id}`,
      {
        headers: {
          "x-access-token": token,
        },
      }
    );
    const data = await response.json();
   // console.log(data);
    setForm({
      district: data.district,
      district_id: data.district_id,
      owner: data.owner,
      leaser: data.leaser,
      year: data.year,
    });

    setGaining(data.gaining);
    setLoosing(data.loosing);
  };

  useEffect(() => {
    gerrit();
  }, []);

  //handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = sessionStorage.getItem("token");
    const sub = { ...form, loosing: loosing, gaining: gaining };
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/updateIntention/${_id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(sub),
      }
    )
        // .then(console.log("Submitted successfully!"));
  };

  return (
    <>
      {" "}
      <div className="sidebar">
        <Sidebar />
      </div>
      <div id="bydrop">
        <h1>Update Intention</h1>

        <form onSubmit={handleSubmit} className="needs-validation">
          <label htmlFor="num-value" className="form-label">
            Year
          </label>
          <div class="input-group mb-3">
            <select
              className="form-select"
              ref={yRef}
              value={form.year}
              id="num-value"
              onChange={yearHandler}
              required
              aria-label="Select example"
            >
              <option value="2025-26">2025-26</option>
              <option value="2024-25">2024-25</option>
              <option value="2023-24">2023-24</option>
              <option value="2022-23">2022-23</option>
              <option value="2021-22">2021-22</option>
              <option value="2020-21">2020-21</option>
              <option value="2019-20">2019-20</option>
              <option value="2018-19">2018-19</option>
              <option value="2017-18">2017-18</option>
              <option value="2016-17">2016-17</option>
              <option value="2015-16">2015-16</option>
              <option value="2014-15">2014-15</option>
              <option value="2013-14">2013-14</option>
              <option value="2012-13">2012-13</option>
              <option value="2011-12">2011-12</option>
              <option value="2010-11">2010-11</option>
            </select>
          </div>

          {/**Station */}
          <label htmlFor="inputGroupSelect07" className="form-label">
            District
          </label>
          <div className="input-group mb-3">
            <select
              className="form-select"
              id="num-value"
              value={form.district}
              onChange={districtHandler}
              ref={dRef}
              required
              aria-label="Select example"
            >
              {districts.map((district) => (
                <option key={district.district_id} value={district.district}>
                  {district.district}
                </option>
              ))}
            </select>
          </div>

          <label htmlFor="num-value" className="form-label">
            Owner
          </label>
          <div class="input-group mb-3">
            <input
              type="number"
              min="0"
              max="100"
              class="form-control"
              value={form.owner}
              ref={oRef}
              onChange={ownerHandler}
              id="num-value"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-default"
              required
            />
          </div>

          <label htmlFor="num-value" className="form-label">
            Leaser
          </label>
          <div class="input-group mb-3">
            <input
              type="number"
              min="0"
              max="100"
              class="form-control"
              disabled
              value={form.leaser}
              ref={leRef}
              onChange={leaserHandler}
              id="num-value"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-default"
              required
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <label
              htmlFor="num-value"
              className="form-label"
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "650px",
              }}
            >
              Loosing
            </label>
            <button
              type="button"
              className="btn btn-dark"
              style={{ borderRadius: "100%" }}
              onClick={handleClick}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-plus"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
              </svg>
            </button>
          </div>
          {loosing.map((val, i) => (
            <div
              key={i}
              id={`num-value-lo-${i}`}
              style={{ display: "flex", alignItems: "center", gap: "20px" }}
            >
              <div style={{ width: "50%" }}>
                <label
                  htmlFor={`num-value-cro-lo-${i}`}
                  style={{ color: "grey" }}
                  className="form-label"
                >
                  Crop
                </label>
                <div className="input-group">
                  <select
                    className="form-select"
                    name="crop"
                    value={val.crop}
                    id={`num-value-cro-lo-${i}`}
                    onChange={(e) => {
                      handleChange(e, i);
                    }}
                    required
                    aria-label="Select example"
                  >
                    <option>Select crop</option>
                    {productOptions.map((productOption) => (
                      <option
                        key={productOption.value}
                        value={productOption.text}
                      >
                        {productOption.text}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div style={{ width: "50%" }}>
                <label
                  htmlFor={`num-value-am-lo-${i}`}
                  style={{ color: "grey" }}
                  className="form-label"
                >
                  Amount
                </label>
                <div className="input-group">
                  <input
                    type="number"
                    className="form-control"
                    name="amount"
                    value={val.amount}
                    onChange={(e) => {
                      handleChange(e, i);
                    }}
                    id={`num-value-am-lo-${i}`}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    required
                    style={{ width: "100%" }} // Adjust width as needed
                  />
                </div>
              </div>
              <br />
              {
                <div>
                  <button
                    style={{ borderRadius: "100%", color: "red" }}
                    type="button"
                    className="btn btn-red"
                    onClick={() => handleDelete(i)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-trash"
                      viewBox="0 0 16 16"
                    >
                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                      <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                    </svg>
                  </button>
                </div>
              }
            </div>
          ))}

          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <label
              htmlFor="num-value"
              className="form-label"
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "650px",
              }}
            >
              Gaining
            </label>
            <button
              type="button"
              className="btn btn-dark"
              style={{ borderRadius: "100%" }}
              onClick={handleClick1}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-plus"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
              </svg>
            </button>
          </div>

          {gaining.map((val, i) => (
            <div
              key={i}
              id={`num-value-ga-${i}`}
              style={{ display: "flex", alignItems: "center", gap: "20px" }}
            >
              <div style={{ width: "50%" }}>
                <label
                  htmlFor={`num-value-ga-cro-${i}`}
                  style={{ color: "grey" }}
                  className="form-label"
                >
                  Crop
                </label>
                <div className="input-group">
                  <select
                    className="form-select"
                    name="crop"
                    value={val.crop}
                    id={`num-value-ga-cro-${i}`}
                    onChange={(e) => {
                      handleChange1(e, i);
                    }}
                    required
                    aria-label="Select example"
                  >
                    <option>Select crop</option>
                    {productOptions.map((productOption) => (
                      <option
                        key={productOption.value}
                        value={productOption.text}
                      >
                        {productOption.text}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div style={{ width: "50%" }}>
                <label
                  htmlFor={`num-value-ga-am-${i}`}
                  style={{ color: "grey" }}
                  className="form-label"
                >
                  Amount
                </label>
                <div className="input-group">
                  <input
                    type="number"
                    className="form-control"
                    name="amount"
                    value={val.amount}
                    onChange={(e) => {
                      handleChange1(e, i);
                    }}
                    id={`num-value-ga-am-${i}`}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    required
                    style={{ width: "100%" }} // Adjust width as needed
                  />
                </div>
              </div>
              <div>
                <button
                  style={{ borderRadius: "100%", color: "red" }}
                  type="button"
                  className="btn btn-red"
                  onClick={() => handleDelete1(i)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
          <button type="submit" className="btn btn-secondary btn-lg">
            Submit
          </button>
        </form>
      </div>
    </>
  );
}
